import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../core/i18n';
import { CartEmptyNotificationComponent } from './cart-empty-notification.component';

@NgModule({
  imports: [CommonModule, I18nModule, NzIconModule],
  declarations: [CartEmptyNotificationComponent],
  exports: [CartEmptyNotificationComponent],
})
export class CartEmptyNotificationModule {}
